(function(root, factory) {
    'use strict';
    if (typeof exports === 'object') {
        // CommonJS
        module.exports = factory();
    }
    if (root) {
        // Global Variables
        root.UEM = root.UEM || {};
        root.UEM.resource = factory();
    }
}(this, function() {
    'use strict';

    var out = {},
        LOADING_FPS = 15,
        RESOURCE_SUFFIX = {
            STYLE: ['css'],
            SCRIPT: ['js'],
            IMG: ['jpg', 'jpeg', 'png', 'gif', 'webp'],
            AUDIO: ['mp3', 'ogg', 'wav', 'm4a']
        },
        TRANSITION_STEP = 4,
        DEFAULT_AVERAGE_SPEED = 0.2,
        resourceRepository = {},

        INTERNATION = 'http://img.ucweb.com',
        NATION = 'http://image.uc.cn',
        INTERNATION_REG = /(http:\/\/img.ucweb.com\/)s(\/.+(png|jpg))/,
        NATION_REG = /(http:\/\/image.uc.cn\/)s(\/.+(png|jpg))/,
        NET_STATUS = {
            LOW: '30',
            HIGH: '75'
        },
        weldParam = {
            isDetectWebp: false,
            isDetectQuality: false,
            isSupportAlphaWebp: false,  //support alpha
            quality: NET_STATUS.HIGH,
            qualityLevel: 'high'
        };

    /**
     * loading state for recoding loading status
     */
    function LoadingState() {
        this.createTime = +new Date();
        this.averageSpeed = DEFAULT_AVERAGE_SPEED;
        this.resourceNum = 0;
        this.waitingNum = 0;
        this.lastWaitingNum = -1;
        this.lastPercent = 0;
        this.virtualFrame = 0;
        this.lastLogicPercent = 0;
        this.transitionPercent = 0;
        this.percent = 0;
    }

    out.checkWebpFeature = function(callback) {
      checkWebpFeature('alpha', callback);
    };

    /**
     * check_webp_feature:
     *    'feature' can be one of 'lossy', 'lossless', 'alpha' or 'animation'.
     *    callback(feature, result)' will be passed back the detection result (in an asynchronous way!)
     */
    function checkWebpFeature(feature, callback) {
        if(weldParam.isDetectWebp && feature==='alpha'){
            callback(feature, true);
            return;
        }
        var kTestImages = {
            lossy: 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA',
            lossless: 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==',
            alpha: 'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==',
            animation: 'UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA'
        };
        var img = new Image();
        img.onload = function() {
            weldParam.isDetectWebp = true;
            var result = (img.width > 0) && (img.height > 0);   //todo，不使用>0，应该是等于特定的数值
            weldParam.isSupportAlphaWebp = result;
            callback(feature, result);
        };
        img.onerror = function() {
            weldParam.isDetectWebp = true;
            weldParam.isSupportAlphaWebp = false;
            callback(feature, false);
        };
        img.src = 'data:image/webp;base64,' + kTestImages[feature];
    }



    /**
     * config
     */
    out.config = function(conf) {
        //配置网络状态对应的图片质量
        NET_STATUS = !!conf.NET_STATUS && conf.NET_STATUS || NET_STATUS;
    };

    /**
     * load resource
     */
    out.loadResource = out.loadEssentialResource = function(queryOrSrcList, finishedCallback, intervalCallback) {
        checkWebpFeature('alpha', function(){
            var srcList = queryOrSrcList;
            if (Object.prototype.toString.call(queryOrSrcList).match(/\[object (\w+)/)[1] === 'String') {
                //img data-src list
                srcList = getImgSrcList(document.querySelectorAll(queryOrSrcList + ' [data-src]'));
            }
            var state = new LoadingState();
            requestEssentialResources(state, srcList);
            startLoadingJob(state, finishedCallback || function() {}, intervalCallback || function() {});
        });
    };

    /**
     * load content resource
     */
    out.loadContentResource = function(query, finishedCallback) {
        checkWebpFeature('alpha', function(){
            nextContentResource(document.querySelectorAll(query + ' [data-src]'), 0, finishedCallback || function() {});
        });
    };

    /**
     * get resource
     */
    out.getResource = function(url) {
        return resourceRepository[url];
    };

    /**
     * weld cdn image with optimized suffix
     */
    out.weld = function(url) {
        if (!isCDNUrl(url) || !shouldOptimize(url) || url.indexOf(',webp')!==-1) {//已经webp直接返回
            return url;
        }

        var quality = getQuality();

        // url = url.replace(/.com\/s/g, '.com\/o').replace(/.cn\/s/g, '.cn\/o');

        url = getWeldUrl(url, quality);

        url = decodeSharpen(url);

        return url;
    };

    /**
     * weld cdn css
     */
    out.weldStyle = function(url){
        if (isCDNUrl(url) && /u_opt=\w+/.test(document.cookie)) {
            var styleNameIndex = url.lastIndexOf('\/') + 1,
                styleName = url.substring(styleNameIndex);

            getQuality();
            url = url.substring(0, styleNameIndex) + (weldParam.isSupportAlphaWebp?'webp':'') + weldParam.qualityLevel + '_' + styleName;
        }

        return url;
    };

    function getWeldUrl(url, quality) {
        return url.replace(INTERNATION_REG, '$1o$2;,' + quality + ',' + (weldParam.isSupportAlphaWebp?'webp':'$3') + ';').replace(NATION_REG, '$1o$2;,' + quality + ',' + (weldParam.isSupportAlphaWebp?'webp':'$3') + ';');
    }

    function isCDNUrl(url) {
        //todo delete
        if(!!window.CONF && window.CONF.closeOpt) {
            return false;
        }
        if(url.indexOf(INTERNATION) === 0 || url.indexOf(NATION) === 0){
            return true;
        }else{
            return false;
        }
    }

    function shouldOptimize(url) {
        if (/u_opt=\w+/.test(document.cookie) && (url.indexOf('.png')>0 || url.indexOf('.jpg'))) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * decode quality param
     */
    // function decodeQuality(url) {
    //     //todo
    //     return url += ';,' + getNetStatus() + ',' + getImgSuffix(url) + ';';
    // }

    /**
     * decode sharpen param
     */
    function decodeSharpen(url) {
        //todo
        return url;
    }


    function getQuality() {
        if(weldParam.isDetectQuality) {
            return weldParam.quality;
        }

        var statusStr = document.cookie.match(/u_net=(\w+)/),
            imgQuality = NET_STATUS.HIGH; //图片品质

        if (!!statusStr) {
            switch (statusStr[1]) {
            case '2g':
                imgQuality = NET_STATUS.LOW;
                weldParam.qualityLevel = 'low';
                break;
            default:
                imgQuality = NET_STATUS.HIGH;
                weldParam.qualityLevel = 'high';
                break;
            }
        }
        weldParam.quality = imgQuality;
        weldParam.isDetectQuality = true;
        return imgQuality;
    }

    // function getImgSuffix(url) {
    //     var isSupportWebpString = document.cookie.match(/u_webp=(\w+)/),
    //         suffix = '';

    //     //is webp already，needn't to change;
    //     if (url.indexOf('.webp') > 0) {
    //         return 'webp';
    //     }

    //     //default img suffix
    //     suffix = url.substr(url.lastIndexOf('.') + 1);

    //     if (!!isSupportWebpString) {
    //         //just change jpg and png to webp
    //         if (url.indexOf('.jpg') > 0 || url.indexOf('.png') > 0) {
    //             suffix = 'webp';
    //         }
    //     }

    //     return suffix;
    // }

    /**
     * load next content one by one
     */
    function nextContentResource(els, next, fcb) {
        if (next < els.length) {
            els[next].onload = function() {
                nextContentResource(els, ++next, fcb);
            };
            els[next].setAttribute('src', out.weld(els[next].getAttribute('data-src')));
        } else {
            fcb();
        }
    }

    /**
     * load all content resource
     */
    function getImgSrcList(els) {
        var srcList = [],
            tmpSrc = '';
        for (var i = 0, n = els.length; i < n; i++) {
            tmpSrc = els[i].getAttribute('data-src');
            srcList.push(tmpSrc);
            //already to load source    // todo
            els[i].setAttribute('src', out.weld(tmpSrc));
        }

        return srcList;

    }

    /**
     * start images loading job
     */
    function startLoadingJob(state, fcb, icb) {
        var percent = 0,
            loadJob = setInterval(function() {
                percent = getLoadingPercent(state);
                icb(percent);
                if (percent === 1) {
                    clearInterval(loadJob);
                    fcb(resourceRepository);
                }
            }, 1000 / LOADING_FPS);
    }

    /**
     * get loading percent
     */
    function getLoadingPercent(state) {
        if (state.resourceNum === 0) {
            return 1;
        }
        var percent = (state.resourceNum - state.waitingNum) / state.resourceNum,
            virtualPercent = getVirtualPercent(state),
            nextPercent = getNextPercent(state),
            logicPercent = 0;
        updateVirtualFrame(state);
        if (virtualPercent >= nextPercent) {
            if (percent === nextPercent) {
                logicPercent = percent;
            } else {
                logicPercent = state.lastPercent;
            }
        } else {
            logicPercent = (state.lastPercent = virtualPercent);
        }
        return transitionPercent(state, logicPercent);
    }

    /**
     * get a transition percent
     */
    function transitionPercent(state, logicPercent) {
        if (state.logicPercent !== logicPercent) {
            state.logicPercent = logicPercent;
            state.transitionPercent = (state.logicPercent - state.percent) / TRANSITION_STEP;
        }
        state.percent += state.transitionPercent;
        if (state.percent > state.logicPercent) {
            state.percent = state.logicPercent;
        }
        return state.percent;
    }

    /**
     * update virtual frame
     */
    function updateVirtualFrame(state) {
        if (state.lastWaitingNum === state.waitingNum) {
            ++state.virtualFrame;
        } else {
            state.lastWaitingNum = state.waitingNum;
            state.virtualFrame = 0;
        }
    }

    /**
     * get virtual percent
     */
    function getVirtualPercent(state) {
        var virtualPercent =
            (state.resourceNum - state.waitingNum + (state.virtualFrame * state.averageSpeed)) / state.resourceNum;
        if (state.lastPercent > virtualPercent) {
            return state.lastPercent;
        } else {
            return virtualPercent;
        }
    }

    /**
     * get percent when next resource loaded
     */
    function getNextPercent(state) {
        var nextNum = 0,
            RESOURCE_CHANNEL_NUM = 4; // to reduce the initial waiting time
        if (state.waitingNum >= RESOURCE_CHANNEL_NUM) {
            nextNum = RESOURCE_CHANNEL_NUM;
        } else {
            nextNum = state.waitingNum;
        }
        return (state.resourceNum - state.waitingNum + nextNum) / state.resourceNum;
    }

    /**
     * send essential resources request, non-ordered
     */
    function requestEssentialResources(state, srcList) {
        var i = 0;
        state.resourceNum = state.waitingNum = srcList.length;
        while (i < srcList.length) {
            var res = resourceRepository[srcList[i]];
            if (res) {
                resourceLoaded(state, res, srcList[i])();
            } else {
                var srcType = getResourceType(srcList[i]);
                switch (srcType) {
                case 'STYLE':
                    res = loadStyleResource(out.weldStyle(srcList[i]));
                    break;
                case 'SCRIPT':
                    res = loadScriptResource(srcList[i]);
                    break;
                case 'AUDIO':
                    res = loadAudioResource(state, srcList[i]);
                    break;
                default:
                    res = new Image();
                    res.crossOrigin = 'anonymous';
                    break;
                }
                if (!(res instanceof Audio)) {
                    res.onload = resourceLoaded(state, res, srcList[i]);
                }
                if (res.type !== 'text/css') {
                    if (srcType === 'IMG') {
                        res.src = out.weld(srcList[i]);
                    } else {
                        res.src = srcList[i];
                    }
                }
            }
            ++i;
        }
    }

    /**
     * load script resource
     */
    function loadScriptResource() {
        var res = document.createElement('script');
        window.document.body.appendChild(res);
        return res;
    }

    /**
     * load style resource
     */
    function loadStyleResource(src) {
        var res = document.createElement('link');
        res.rel = 'stylesheet';
        res.type = 'text/css';
        res.href = src;
        window.document.getElementsByTagName('head')[0].appendChild(res);
        return res;
    }

    /**
     * load audio resource
     */
    function loadAudioResource(state, src) {
        var res = new Audio();
        res.autoplay = false;
        res.preload = true;
        resourceLoaded(state, res, src)();
        return res;
    }

    /**
     * get resouce type
     */
    function getResourceType(src) {
        var i = 0,
            p = '';
        for (p in RESOURCE_SUFFIX) {
            if (RESOURCE_SUFFIX.hasOwnProperty(p)) {
                i = RESOURCE_SUFFIX[p].length;
                while (i--) {
                    if (src.indexOf('.' + RESOURCE_SUFFIX[p][i]) > 0) {
                        return p;
                    }
                }
            }
        }
    }

    /**
     * resource loaded callback
     */
    function resourceLoaded(state, res, src) {
        return function() {
            setTimeout(function() {
                resourceRepository[src] = res;
                --state.waitingNum;
                state.averageSpeed = calculateAverageSpeed(state);
            }, 50); // fix NaN bug, make time different
        };
    }

    /**
     * calculate average speed
     */
    function calculateAverageSpeed(state) {
        return (state.resourceNum - state.waitingNum) /
            ((+new Date() - state.createTime) / (1000 / LOADING_FPS));
    }

    function getUCParamStr(target) {
        if (window.__UC_PARAMS__) {
          // broccoli 下发公参
          var ucParams = window.__UC_PARAMS__;
          if (ucParams[target]) return ucParams[target];
        }
      
        var reg = new RegExp('&' + target + '=([^&]*)');
        var match = reg.exec(window.location.search);
      
        return match && match[1] ? decodeURIComponent(match[1]) : '';
      }

    /**
     * 居于网络情况使用webp格式图片
     * @param  cb 回调函数
     * @param  nw 公参nw值，空值时，从 Broccoli 下发公参获取
     */
    out.useWebpStyle = function(cb,nw) {
        if (!nw) nw = getUCParamStr('nw');
        nw = nw.toLowerCase();

        setWebpCookie(nw);
        if(cb) cb();
    };

    function setWebpCookie(nw){
        if ('2g' === nw || '2.75g' === nw || '2.5g' === nw) {
            setCookie('u_net', '2g', 30);
            setCookie('u_opt', 'true', 30);
        } else if ('3g' === nw) {
            setCookie('u_net', '3g', 30);
            setCookie('u_opt', 'true', 30);
        } else if ('wifi' === nw || '4g' === nw) {
            setCookie('u_net', 'wifi', 30);
            setCookie('u_opt', 'true', 30);
        } else {
            deleteCookie('u_net');
            deleteCookie('u_opt');
        }
    }
    function setCookie(key, value, expiredays) {
        var exdate = new Date();
        exdate.setDate(exdate.getDate() + expiredays);
        document.cookie = key + '=' + window.escape(value) +
            ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString());
    }

    function deleteCookie(key) {
        document.cookie = key + '=;expires=' + (new Date(0)).toGMTString();
    }

    return out;
}));
